import ConditionManagePaneStandardCondition from "./ConditionManagePaneStandardCondition";

export default ConditionManagePaneStandardCondition;
export { ConditionManagePaneStandardCondition };
